import React from 'react'
import styles from './Button.module.css'

interface ButtonProps {
  children: React.ReactNode
  onClick: () => void
  disabled?: boolean
  primary?: boolean
  secondary?: boolean
  size?: 'Small' | 'Medium' | 'Large'
  width?: 'Auto' | 'Full'
}

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  disabled,
  primary,
  secondary,
  size = 'Medium',
  width = 'Auto',
  ...rest
}) => {
  const className = [
    styles.ButtonClass,
    primary ? styles.Primary : '',
    secondary ? styles.Secondary : '',
    styles[size],
    disabled ? styles.Disabled : '',
    styles[width],
  ].join(' ').trim()

  return (
    <button className={className} onClick={disabled ? undefined : onClick} disabled={disabled} {...rest}>
      {children}
    </button>
  )
}
